import React from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

type DetailGroupProps = {
  name: string;
  children?: React.ReactNode;
  sx?: SxProps;
};

export const DetailGroup = ({ name, children, sx }: DetailGroupProps) => {
  return (
    <Box
      sx={{
        marginBottom: '32px',
        ...sx,
      }}
    >
      <Box
        sx={{
          margin: '0 -16px 8px',
          paddingLeft: '16px',
          backgroundColor: ({ palette }: Theme) => palette.primary.light,
        }}
      >
        <Typography variant='caption' fontWeight='bold'>
          {name}
        </Typography>
      </Box>
      <Box
        className='detail-group-grid'
        sx={{
          display: 'grid',
          gap: 0.5,
          columnGap: 2,
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', // Use 2 columns when space allows, but prevent overflow
          '& > *': {
            minWidth: 0,
            maxWidth: '100%', // Ensure items don't exceed container width
          },
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
